import { ref } from 'vue'

const COOKIE_CONSENT_KEY = 'remaps-cookie-consent'

const cookieSettingsVisible = ref(false)

export function useCookieConsent() {
  function getConsent(): string | null {
    return localStorage.getItem(COOKIE_CONSENT_KEY)
  }

  function hasMadeDecision(): boolean {
    return getConsent() !== null
  }

  function showCookieSettings() {
    cookieSettingsVisible.value = true
  }

  function hideCookieSettings() {
    cookieSettingsVisible.value = false
  }

  function acceptCookies() {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted')
    hideCookieSettings()
  }

  function rejectCookies() {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'rejected')
    hideCookieSettings()
  }

  return {
    cookieSettingsVisible,
    getConsent,
    hasMadeDecision,
    showCookieSettings,
    hideCookieSettings,
    acceptCookies,
    rejectCookies,
  }
}
